import { isChannel } from "@website/utils/channel/helpers";

const persianRegex = new RegExp(
  [
    "اسنپ تریپ", // فاصله معمولی + ی فارسی
    "اسنپ‌تریپ", // نیم‌فاصله + ی فارسی
    "اسنپ‌ تریپ", // نیم‌فاصله + فاصله + ی فارسی
    "اسنپتریپ", // چسبیده + ی فارسی
    "اسنپ تريپ", // فاصله معمولی + ی عربی
    "اسنپ‌تريپ", // نیم‌فاصله + ی عربی
    "اسنپ‌ تريپ", // نیم‌فاصله + فاصله + ی عربی
    "اسنپتريپ", // چسبیده + ی عربی
    "اسنپ ترئپ", // فاصله معمولی + ئ
    "اسنپ‌ترئپ", // نیم‌فاصله + ئ
    "اسنپ‌ ترئپ", // نیم‌فاصله + فاصله + ئ
    "اسنپترئپ" // چسبیده + ئ
  ].join("|"),
  "gi"
);

const englishRegex = new RegExp("snapp trip|snapptrip", "gi");

export const replaceSnappTripBasedOnChannel = (text: string) => {
  if (isChannel(["snapp-ir"]))
    return text
      .replaceAll(persianRegex, "اسنپ")
      .replaceAll(englishRegex, "Snapp")
      .replaceAll(new RegExp("undefined|NaN|null", "gi"), "");
  return text;
};
